var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIconV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "secure-icon-v2_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h20v20H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#secure-icon-v2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.994 18c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 014.5 16.5v-8c0-.412.147-.766.44-1.06C5.235 7.148 5.588 7 6 7h.5V5c0-1.107.39-2.05 1.171-2.83C8.452 1.39 9.397 1 10.505 1s2.05.39 2.828 1.17C14.111 2.95 14.5 3.893 14.5 5v2h.5c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v8c0 .413-.147.766-.44 1.06A1.45 1.45 0 0115 18H5.993zm4.51-4c.414 0 .767-.147 1.059-.442.291-.294.437-.649.437-1.062 0-.414-.147-.767-.442-1.059A1.456 1.456 0 0010.496 11c-.414 0-.767.147-1.059.442A1.456 1.456 0 009 12.504c0 .414.147.767.442 1.059.295.291.649.437 1.062.437zM8 7h5V5c0-.694-.243-1.285-.73-1.77a2.41 2.41 0 00-1.77-.73 2.41 2.41 0 00-1.77.73A2.41 2.41 0 008 5v2z",
    fill: "#fff"
  }))));
}
export default SvgSecureIconV2;